export interface AssetTagRelationshipsState {
  isLoading: boolean;
}

export const defaultState: AssetTagRelationshipsState = {
  isLoading: false,
};
